import utils from 'utils';

import {useCart, useEshopConfig, useLabel} from '@/hooks/export';

export const CartContactSummary = (props: {
    fields: any // todo: any are you okay
}) => {
    const label = useLabel();
    const {layout} = useEshopConfig().cartContactForm;
    const {flags} = useCart();

    const data = {
        layout: [
            {title: label.billingAddress},
            {title: flags.isMontaz ? label.executionAddress : label.deliveryAddress},
            {title: label.contactPerson},
        ],
    };

    return <div className={cmpClass}>
        {
            layout.map((group, groupI) => {
                return <div className={classMap.group} key={groupI}>
                    <p className={classMap.title}>
                        {data.layout[groupI].title}
                    </p>
                    <div className={classMap.grid}>
                        {
                            group.grid.map((item, itemI) => {
                                return ['inputText', 'inputPhone', 'inputEmail'].includes(item.type) ?
                                    <div className={classMap.gridItem} key={itemI}>
                                        <span>{item.label}:</span>
                                        <span>{props.fields[item.name]}</span>
                                    </div> :
                                    <></>;
                            })
                        }
                    </div>
                </div>;
            })
        }
    </div>;
};

const cmpClass = 'cart-contact-summary';
const classMap = utils.generateClassMap(cmpClass, {
    checkbox: 'checkbox',
    grid: 'grid',
    gridItem: 'grid-item',
    group: 'group',
    inputText: 'input-text',
    select: 'select',
    text: 'text',
    title: 'title',
});
